import { useEffect } from 'react';

type Props = {
  flag: boolean;
  action: () => void;
  delayMs?: number;
};

export const UseEffectOnTrue = ({ flag, action, delayMs = 0 }: Props) => {
  useEffect(() => {
    if (!flag) return;
    const timer = setTimeout(() => action(), delayMs);
    return () => clearTimeout(timer);
  }, [flag, action, delayMs]);

  return null;
};
